// extracted by mini-css-extract-plugin
module.exports = {"container":"Employer_container__tXtkj","searchDiv":"Employer_searchDiv__164qp","title":"Employer_title__2DIqt","searchWrap":"Employer_searchWrap__9jZUj"};